/**
 * Created by heldernunes on 31/05/16.
 */

window.dietsNS = {
    //private variables
    _row: null,
    _action: null,
    _callback:null,

    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id), actionId = parseInt(action.wf_action_id);

        dietsNS._action = action;
        dietsNS._row = row;
        dietsNS._callback = callback;

        if (actionId == 3 || actionId == 13) {
            dietsNS.openReason(dietsNS.updateStateDietRequisition)
        } else {
            dietsNS.executeGenericAction();
        }

    },

    executeGenericAction: function () {
        workflow.executeAction(dietsNS._action, dietsNS._callback, dietsNS._row);
    },

    openReason:function (callback) {
        Hades.showLoading();

        var params = {
            task_id:dietsNS._action.task_id,
            wf_id:dietsNS._action.wf_id,
            wf_status_id:dietsNS._action.to_state_id,
            wf_action_id:dietsNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                dietsNS._callback(false, dietsNS._action, dietsNS._row);
            });
    },

    updateStateDietRequisition: function (event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {
            task_id:dietsNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:dietsNS._action.wf_id,
            wf_status_id:dietsNS._action.to_state_id,
            wf_action_id:dietsNS._action.wf_action_id
        };

        $.post('/requisition/update_state_diet_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    dietsNS._callback(false, dietsNS._action, dietsNS._row);
                } else {
                    dietsNS._callback(true, dietsNS._action, dietsNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                dietsNS._callback(false, dietsNS._action, dietsNS._row);
            });
    }

}
